export default __webpack_public_path__ + "static/media/rubyrails.704da0e5.png";